export default __webpack_public_path__ + "static/media/little-check.16eb91db.svg";